import { render, staticRenderFns } from "./chaffCityStatistics.vue?vue&type=template&id=0b758b8a&scoped=true&"
import script from "./chaffCityStatistics.vue?vue&type=script&lang=js&"
export * from "./chaffCityStatistics.vue?vue&type=script&lang=js&"
import style0 from "./chaffCityStatistics.vue?vue&type=style&index=0&id=0b758b8a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b758b8a",
  null
  
)

export default component.exports